import { noop } from 'svelte/internal';
import { DateTime } from './lib/date-time';
import InputDateRange from './InputDateRange.svelte';
import InputSingleDate from './InputSingleDate.svelte';
globalThis['datePicker'] = {
    version: VERSION,
    environment: isProduction ? 'production' : 'development',
    InputDateRange,
    InputSingleDate,
};
createCustomElement('date-input', InputSingleDate, {
    props: {
        language: stringWithDefault('de'),
        minDate: (value) => value === 'now' ? DateTime.now.date : DateTime.parseOrDefault(value),
        overlay: options('inline', 'modal'),
        picker: options('day', 'month', 'year'),
    },
    members: {
        get date() { var _a; return (_a = this.element) === null || _a === void 0 ? void 0 : _a.getValue(); },
        set date(value) { var _a; (_a = this.element) === null || _a === void 0 ? void 0 : _a.setValue(value); },
        open() { this.element.open(); },
        close() { this.element.close(); },
    }
}, HTMLInputElement, { extends: 'input' });
createCustomElement('date-picker', InputDateRange, {
    props: {
        language: stringWithDefault('de'),
        minDate: (value) => value === 'now' ? DateTime.now.date : DateTime.parseOrDefault(value),
        minStay: int,
        mode: options('standalone', 'content'),
        rangeMode: boolean,
        placeholder: string,
        overlay: options('inline', 'modal'),
        picker: options('day', 'month', 'year'),
        readonly: boolean,
    },
    init(props) {
        if (props.mode == 'standalone') {
            this.classList.add('date-picker');
        }
        props.inputFrom = this.querySelector("[date-picker-from]") || document.querySelector(this.getAttribute('date-picker-from'));
        props.inputTo = this.querySelector("[date-picker-to]") || document.querySelector(this.getAttribute('date-picker-to'));
    },
    members: {
        get value() { var _a; return (_a = this.element) === null || _a === void 0 ? void 0 : _a.getValue(); },
        set value(value) { var _a; (_a = this.element) === null || _a === void 0 ? void 0 : _a.setValue(value); },
        open() { this.element.open(); },
        close() { this.element.close(); },
    },
    style: `
        .date-picker {
            display: inline-block;
            background-color: #fff;
            color: #000;
            border: inset 1px rgb(118, 118, 118);
            border-radius: 2px;
            padding: 1px 2px;
            text-align: center;
            width: 200px;
            user-select: none;
            cursor: pointer;
        }
    `
});
function createCustomElement(tagName, Component, options = {}, BaseHTMLElement = HTMLElement, defineOptions) {
    const props = options.props || {};
    const init = options.init || noop;
    const members = options.members || {};
    const customElement = class extends BaseHTMLElement {
        constructor() {
            super();
        }
        static get observedAttributes() { return Object.keys(props).map(dashCase); }
        connectedCallback() {
            const properties = Object.keys(props).reduce((o, name) => ({
                ...o,
                [name]: props[name](this.getAttribute(dashCase(name))),
            }), {});
            init.call(this, properties);
            this.element = new Component({
                target: this,
                props: {
                    host: this,
                    ...properties,
                }
            });
        }
        attributeChangedCallback(name, oldValue, newValue) {
            var _a;
            name = camelCase(name);
            (_a = this.element) === null || _a === void 0 ? void 0 : _a.$set({ [name]: props[name](newValue) });
        }
        disconnectedCallback() {
            this.element.$destroy();
            this.element = null;
        }
    };
    for (const name of Object.keys(members)) {
        const prop = Object.getOwnPropertyDescriptor(members, name);
        Object.defineProperty(customElement.prototype, name, prop);
    }
    insertStyle(options.style);
    customElements.define(tagName, customElement, defineOptions);
    function dashCase(value) {
        return value.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
    }
    function camelCase(value) {
        return value.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
    }
    function insertStyle(css) {
        if (css) {
            var style = document.createElement('style');
            style.textContent = css;
            const fistStyle = document.head.querySelector('style, link');
            fistStyle ? document.head.insertBefore(style, fistStyle) : document.head.appendChild(style);
        }
    }
}
function stringWithDefault(def) { return (value) => value || def; }
function string(value) { return value; }
function int(value) { return parseInt(value); }
function boolean(value) { return typeof value === 'string' && value !== 'false'; }
function booleanWithDefault(def) { return (value) => value == undefined ? def : boolean(value); }
function options(...values) { return (value) => values.indexOf(value) === -1 ? values[0] : values[values.indexOf(value)]; }
